// extracted by mini-css-extract-plugin
export var actionText = "_sn-4";
export var container = "_sn-0";
export var leftSection = "_sn-1";
export var rightSection = "_sn-2";
export var settingsButton = "_sn-6";
export var settingsIcon = "_sn-7";
export var shortcut = "_sn-5";
export var shortcutGroup = "_sn-3";